
import Vue from 'vue';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import ListItem from '@/components/base/ListItem.vue';

export default Vue.extend({
	name: 'RunnitTemplatesOnboardingDialog',
	components: {
		DialogOrBottomSheet,
		ListItem,
	},
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
});
